import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Bell, CheckCheck, Info, AlertTriangle, CheckCircle2 } from "lucide-react";
import { Link } from "react-router-dom";

const SEVERITY = {
  info: { icon: Info, color: "text-[#2D6BFF]", bg: "bg-[#EAF0FF]" },
  success: { icon: CheckCircle2, color: "text-[#1F9D6A]", bg: "bg-[#E9F8F1]" },
  warning: { icon: AlertTriangle, color: "text-[#B7791F]", bg: "bg-amber-50" },
  error: { icon: AlertTriangle, color: "text-red-600", bg: "bg-red-50" },
};

export const NotificationsView = () => {
  const [items, setItems] = useState([]);
  const refresh = () => api.get("/notifications/").then(r => setItems(r.data || [])).catch(() => {});
  useEffect(() => { refresh(); }, []);
  const markAll = async () => { try { await api.post("/notifications/read-all"); refresh(); } catch (e) {} };
  const markOne = async (id) => { try { await api.post(`/notifications/${id}/read`); refresh(); } catch (e) {} };
  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="font-display text-2xl font-bold text-slate-900">Notifiche</h1>
          <p className="text-sm text-slate-600">Centro notifiche</p>
        </div>
        <Button variant="outline" onClick={markAll}><CheckCheck size={14} className="mr-1" /> Segna tutte come lette</Button>
      </div>
      <div className="space-y-2">
        {items.map(n => {
          const S = SEVERITY[n.severity] || SEVERITY.info;
          const Icon = S.icon;
          return (
            <div key={n.id} className={`cxo-card p-4 flex items-start gap-3 ${!n.read ? "border-l-4 border-l-[#2D6BFF]" : ""}`}>
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center ${S.bg}`}>
                <Icon size={18} className={S.color} />
              </div>
              <div className="flex-1">
                <p className="font-semibold text-slate-900">{n.title}</p>
                <p className="text-sm text-slate-600 mt-0.5">{n.body}</p>
                <div className="mt-2 flex items-center gap-2">
                  <p className="text-xs text-slate-500">{new Date(n.created_at).toLocaleString("it-IT")}</p>
                  {n.link && <Link to={n.link} className="text-xs text-[#2D6BFF] font-semibold">Apri</Link>}
                </div>
              </div>
              {!n.read && <Button size="sm" variant="ghost" onClick={() => markOne(n.id)}>Segna come letta</Button>}
            </div>
          );
        })}
        {!items.length && <div className="cxo-card p-10 text-center text-slate-500"><Bell size={32} className="mx-auto text-slate-300" /><p className="mt-2">Nessuna notifica</p></div>}
      </div>
    </div>
  );
};
